import { Fragment } from 'react';
import styled from '@emotion/styled';
import { Resort, Hotel } from '@model/common';
import { LinkItem } from '@components/sitemap/styles';
import { DestinationLink } from '@components/common/next-link';
import { TestId } from '@components/test-ids';

export interface SitemapResortsProps {
  resorts: Array<Resort>;
}

const StyledList = styled.ul({
  marginBottom: 10
});

export const SitemapResorts = ({ resorts }: SitemapResortsProps) => {
  return (
    <div data-testid={TestId.sitemap.resorts.container}>
      <ul>
        {resorts
          .sort((a: Resort, b: Resort) => a.display.localeCompare(b.display))
          .map(({ path: resortPath, display: resortDisplay, holidays }: Resort) => {
            return (
              <Fragment key={resortPath}>
                <LinkItem data-testid={TestId.sitemap.resorts.resort}>
                  <DestinationLink path={resortPath}>{resortDisplay}</DestinationLink>
                  <StyledList>
                    {holidays?.map((hotel: Hotel) => {
                      const { path: hotelPath, display: hotelDisplay } = hotel;
                      return (
                        <LinkItem data-testid={TestId.sitemap.resorts.hotel} key={hotelPath}>
                          <DestinationLink path={hotelPath}>{hotelDisplay}</DestinationLink>
                        </LinkItem>
                      );
                    })}
                  </StyledList>
                </LinkItem>
              </Fragment>
            );
          })}
      </ul>
    </div>
  );
};
